import { FC, useCallback } from "react";
import { StyledHeader, StyledFooter, StyledFooterLink } from "./style";
import { Card } from "../../Common/Card";
import {
  Communication,
  Company,
  Notification,
  ScreenConfig,
} from "../../../types";
import SectionTitle from "../../Common/SectionTitle";
import { ListGroup, ListGroupItem } from "../../Common/ListGroup";
import { useTranslation } from "react-i18next";
import { Row } from "../../Common/Grid";
import Item from "./Item";
import { useNavigate } from "react-router-dom";
import { CommunicationsEmptyState } from "../../Communications/EmptyState";

type Props = {
  communications: Communication[];
  companyId: Company["Id"];
  config: ScreenConfig;
  enabled?: boolean;
};

export const CommunicationsWidget: FC<Props> = ({
  communications,
  companyId,
  config,
  enabled = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Icon } = config;

  const handleItemClick = useCallback(
    (notificationId: Notification["Id"]) => {
      navigate(`/company/${companyId}/communications/${notificationId}`);
    },
    [companyId, navigate]
  );

  return (
    <Card height="100%">
      <StyledHeader color={config.theme.primaryColor}>
        <Row alignItems="center" paddingLeft="1rem">
          <Icon color={config.theme.primaryColor} />
          <SectionTitle title={t("components.menu.communications")} />
        </Row>
      </StyledHeader>
      {enabled ? (
        <>
          <ListGroup flush>
            {communications.length === 0 && (
              <CommunicationsEmptyState
                message={t("components.communications.emptyStateWidget")}
              />
            )}
            {communications.map((communication) => (
              <ListGroupItem
                key={communication.Id}
                display="flex"
                px={[null, "20px"]}
              >
                <Item communication={communication} onClick={handleItemClick} />
              </ListGroupItem>
            ))}
          </ListGroup>
          <StyledFooter>
            <StyledFooterLink path={`/company/${companyId}/communications`}>
              {t("components.communicationsWidget.viewAll")}
              <i className="icon ion-md-arrow-down mg-l-5" />
            </StyledFooterLink>
          </StyledFooter>
        </>
      ) : (
        <CommunicationsEmptyState
          message={t("components.communications.disabled")}
        />
      )}
    </Card>
  );
};
